import TextInput from "./TextInput";
import InputMui from "./InputMui";

export { TextInput, InputMui };

export default TextInput;
